module.exports = __webpack_public_path__ + "../static/img/canon_logo.491447e2.png";